import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const FlagIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M2.862 0H1.517a.43.43 0 0 0-.429.429l-.01 10.47a1.103 1.103 0 0 0 2.203 0l.01-10.47A.427.427 0 0 0 2.861 0zM10.646 3.642L3.995 1.231l-.006 5.61 6.657-2.413a.417.417 0 0 0 0-.786z"
    />
  </svg>
);

FlagIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

FlagIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(12, 12),
};

export default FlagIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/flag.js